PJQ.views.invoicing.ReceivableInvoicesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'receivable-invoices-list'),
        invoiceId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-create-invoice': 'createInvoice',
        'click .btn-delete-invoice': 'deleteInvoiceClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');

        if (this.collection == null) {
            this.collection = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                project: PJQ.app.session.project,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchReceivableInvoiceCustomFields();
        this.userSettings = await PJQ.app.session.fetchReceivableInvoiceUserSettings();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('receivableInvoiceChanged');
        PJQ.app.session.project.on('receivableInvoiceChanged', function (invoice) {
            this.collection.add(invoice);
            this.render();
        }, this);

        if (this.options.invoiceId > 0) {
            let initInvoice = this.collection.get(this.options.invoiceId);
            if (initInvoice != null) {
                this.viewInvoice(initInvoice);
                this.options.invoiceId = null;
            }
        } else if (this.options.paymentId > 0) {
            let initPayment = new PJQ.models.invoicing.ReceivableInvoicePayment({
                id: this.options.paymentId
            });

            new PJQ.views.invoicing.InvoicePaymentModal({
                model: initPayment
            });
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.invoicing.ReceivableInvoiceDataTable({
            el: this.$('.invoices-table'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            showAllBillingPeriods: this.options.showAllBillingPeriods,
            headerData: _.bind(function () {
                return {
                    billingPeriods: this.billingPeriodSettings ? this.billingPeriodSettings.billingPeriods : null,
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            groups: this.groups,
            costTypes: this.costTypes,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            billingPeriodSettings: this.billingPeriodSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.invoicing.view.RECEIVABLE_INVOICES),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewInvoice: (invoice) => {
                this.viewInvoice(invoice);
            },
            onRowDoubleClick: (row) => {
                this.viewInvoice(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    createInvoice: function () {
        this.viewInvoice();
    },
    viewInvoice: function (invoice) {
        let isNew = invoice == null
        this.invoiceEditor = new PJQ.views.invoicing.EditReceivableInvoiceModal({
            model: invoice,
            primeContract: this.model,
            onSave: (invoice) => {
                if (isNew) {
                    this.collection.add(invoice);
                }
                this.renderView();
            },
            onDelete: (invoice) => {
                this.collection.remove(invoice);
                this.renderView();
            }
        });
    },
    deleteInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteInvoice(row);
    },
    deleteInvoice: function (row) {
        if (row != null) {
            let invoice = row.data();
            if (invoice != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Invoice",
                    body: "Are you sure you want to delete this Invoice?",
                    onDelete: _.bind(function () {
                        invoice.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(invoice);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.invoicing.ReceivableInvoiceSettingsModal({
            invoicesView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    }
});

PJQ.views.invoicing.ModalViewReceivableInvoices = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-view-receivable-invoices'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.invoicing.ReceivableInvoicesList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                showAllBillingPeriods: this.options.showAllBillingPeriods,
                project: this.options.project
            })
        }
    },
});